
import common from './common'
import debugHelper from '../../util/debug'
import functions from '../../functions'
import msgbus from '../../msgBus'



var work = {

  // 设置任务角标
  setTaskBadge() {
    // 获取任务未完成数量
    var taskCount = msgbus.vm.getUserAwaitingTaskTotalCount()

    // 设置工作角标
    msgbus.vm.setTaskTips({ value: taskCount })

  },

  /**
     * 计算未处理任务数量
     * @param {*} vm
     * @param {*} funcList
     */
  funcFetchTaskForBadge: function (vm, funcList) {
    console.log('调试代码')
    debugHelper.log('funcFetchTaskForBadge: 计算未处理任务数量')

    if (window.userAwaitingTasksTotalCountController) {
      window.userAwaitingTasksTotalCountController.abort()
      window.userAwaitingTasksTotalCountController = undefined
    }
    const userAwaitingTasksTotalCountController = new AbortController()
    window.userAwaitingTasksTotalCountController =
      userAwaitingTasksTotalCountController

    vm.fetchUserAwaitingTasksTotalCount({
      authorization: {
        Authorization: 'Bearer ' + vm.getAccountToken()
      },
      tid: vm.getCurrentTenantID(),
      vm: vm,
      prompt: false,
      signal: userAwaitingTasksTotalCountController.signal,
    }).then(
      () => {
        if (
          window.userAwaitingTasksTotalCountController ===
          userAwaitingTasksTotalCountController
        ) {
          window.userAwaitingTasksTotalCountController = undefined
        }
        functions.work.setTaskBadge()
        if (funcList) {
          common.callNextFunc(vm, funcList)
        }
      },
      () => {
        if (
          window.userAwaitingTasksTotalCountController ===
          userAwaitingTasksTotalCountController
        ) {
          window.userAwaitingTasksTotalCountController = undefined
        }
      }
    )
  },

}

export default work